import i18n from 'i18next';
import {LocalizedString} from '../../backend/interfaces/localized-string';
import {AppLanguageTag} from '../../i18n/types';

export const getLocalizedFieldValue = (record: Record<string, any>, fieldName: string): string => {
  let value: string | undefined;

  const localizedField = record[`${fieldName}Localized`] as LocalizedString | undefined;

  switch (i18n.language) {
    case AppLanguageTag.ptPT:
      value = localizedField?.ptPT;
      break;
    case AppLanguageTag.esES:
      value = localizedField?.esES;
      break;
    case AppLanguageTag.glES:
      value = localizedField?.glES;
      break;
    case AppLanguageTag.enUS:
      value = localizedField?.enUS;
      break;
    case AppLanguageTag.ptBR:
      value = localizedField?.ptBR;
      break;
  }

  // Fallback to the non-localized field, otherwise return an empty string
  return value || (record[fieldName] as string) || '';
};
